import React, { useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  CssBaseline,
  Grid,
  Link,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useRequestPasswordReset } from '@/lib/api/auth';
import { PublicOnlyGuard } from '@/features/auth/PublicOnlyGuard.tsx';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const { mutateAsync: requestReset } = useRequestPasswordReset();

  const handleEmailChange = (event: { target: { value: React.SetStateAction<string> } }) => {
    setEmail(event.target.value);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    if (email.trim() === '') {
      setMessage('Por favor, ingresa tu correo electrónico.');
      setOpenSnackbar(true);
      return;
    }

    try {
      await requestReset(email);
      setMessage('Correo de restablecimiento de contraseña enviado. Por favor, revisa tu email.');
      setOpenSnackbar(true);
    } catch (error) {
      setMessage(
        'Error al enviar el correo de restablecimiento. Por favor, verifica que el correo electrónico sea correcto.'
      );
      setOpenSnackbar(true);
      console.error('Error enviando correo de restablecimiento:', error);
    }
  };

  return (
    <PublicOnlyGuard>
      <Grid container component="main" sx={{ minHeight: '100dvh' }}>
        <CssBaseline />
        <Grid item xs={12} component={Paper} elevation={6} square>
          <Box
            sx={{ my: 8, mx: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Restablecer Contraseña
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1, maxWidth: 400 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Dirección de email"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={handleEmailChange}
              />
              <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                Enviar Correo de Restablecimiento
              </Button>
              <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                message={message}
              />
              <Grid container>
                <Grid item>
                  <Link href="/login" variant="body2">
                    {'Regresar al inicio de sesión'}
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </PublicOnlyGuard>
  );
}

export default ForgotPassword;
